const WEEK_DAYS = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];
const MONTHS = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря',
];

/**
 * Даты приходят строкой YYYY-MM-DD в таймзоне мастера и разбираются вручную.
 * Через Date их пропускать нельзя: браузер клиента в другом часовом поясе
 * сдвинул бы день на сутки.
 */
function parseLocalDate(date: string): { year: number; month: number; day: number } {
  const [year, month, day] = date.split('-').map(Number);
  return { year: year ?? 0, month: month ?? 1, day: day ?? 1 };
}

export function dayNumber(date: string): string {
  return String(parseLocalDate(date).day);
}

export function weekDayLabel(date: string): string {
  const { year, month, day } = parseLocalDate(date);
  return WEEK_DAYS[new Date(Date.UTC(year, month - 1, day)).getUTCDay()] ?? '';
}

export function monthLabel(date: string): string {
  const { month } = parseLocalDate(date);
  return MONTHS[month - 1]?.slice(0, 3) ?? '';
}

export function fullDateLabel(date: string): string {
  const { day, month } = parseLocalDate(date);
  return `${day} ${MONTHS[month - 1] ?? ''}, ${weekDayLabel(date)}`;
}

export function durationLabel(minutes: number): string {
  if (minutes < 60) {
    return `${minutes} мин`;
  }

  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;

  return rest === 0 ? `${hours} ч` : `${hours} ч ${rest} мин`;
}
